import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getLanguageTranslations, updateLanguageTranslations } from "../../store/language/language.action";
import Button from "../../extra/Button";
import { setToast } from "../../../util/toast";
import { usePermission } from "../../../hooks/usePermission";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 0,
    borderRadius: '12px',
    overflow: 'hidden'
};

const TranslationInfoDialogue = () => {
    const dispatch = useDispatch();

    const { can } = usePermission();
    const canEdit = can("App Language", "Edit");


    const { dialogueData } = useSelector((state) => state.dialogue);
    const { translations, isLoading } = useSelector((state) => state.language);

    console.log("translations", translations);

    const [search, setSearch] = useState("");
    const [module, setModule] = useState("app");
    const [localEdits, setLocalEdits] = useState({});

    useEffect(() => {
        if (dialogueData) {
            dispatch(getLanguageTranslations({ languageCode: dialogueData.languageCode, module, search }));
        }
    }, [dispatch, dialogueData, module, search]);

    useEffect(() => {
        setLocalEdits({});
    }, [module, dialogueData?.languageCode]);

    const handleClose = () => {
        dispatch({ type: CLOSE_DIALOGUE });
    };

    const handleInputChange = (key, value) => {
        setLocalEdits((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSubmit = () => {
        if (Object.keys(localEdits).length === 0) {
            setToast("info", "No changes made");
            handleClose();
            return;
        }

        const payload = {
            languageCode: dialogueData.languageCode,
            module,
            translations: localEdits,
        };

        dispatch(updateLanguageTranslations(payload));
        setLocalEdits({});
        handleClose();
    };

    return (
        <Modal open={true} onClose={handleClose}>
            <Box sx={style}>
                <div className="model-header p-3 border-bottom">
                    <p className="m-0 fs-5 fw-bold">Translations : {dialogueData?.languageTitle} ({dialogueData?.languageCode})</p>
                </div>
                <div className="model-body">
                    {/* Tabs */}
                    <div className="d-flex border-bottom">
                        <div
                            className={`p-3 w-50 text-center cursor-pointer ${module === "app" ? "bottom-border-color" : "text-secondary"}`}
                            onClick={() => setModule("app")}
                            style={{ cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            App
                        </div>
                        <div
                            className={`p-3 w-50 text-center cursor-pointer ${module === "web" ? "bottom-border-color" : "text-secondary"}`}
                            onClick={() => setModule("web")}
                            style={{ cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            Web
                        </div>
                    </div>

                    {/* Search Bar */}
                    <div className="p-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={`Search ${module} translation keys or values...`}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <div className="px-3 pb-3">
                        <div className="translation-container" style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #eee", borderRadius: "8px" }}>
                            <table className="table mb-0">
                                <thead className="sticky-top bg-white">
                                    <tr>
                                        <th style={{ width: "40%" }}>KEY</th>
                                        <th style={{ width: "60%" }}>TRANSLATION VALUE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="2" className="text-center py-4">Translations keys or values</td>
                                        </tr>
                                    ) : (
                                        <>
                                            {translations && Object.entries(translations.translations || {}).map(([key, value], index) => (
                                                <tr key={index}>
                                                    <td className="align-middle fw-bold" style={{ fontSize: '13px' }}>{key}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={localEdits[key] !== undefined ? localEdits[key] : value}
                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                            style={{ fontSize: '13px' }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {(!translations || Object.keys(translations.translations || {}).length === 0) && (
                                                <tr>
                                                    <td colSpan="2" className="text-center py-4">No translations found</td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="model-footer p-3 border-top">
                    <div className="d-flex justify-content-end gap-2">
                        <Button
                            btnName="Close"
                            onClick={handleClose}
                            btnColor="myCustomButton"
                            style={{ borderRadius: "5px", width: "80px" }}
                        />
                        {canEdit && (
                            <Button
                                btnName="Submit"
                                onClick={handleSubmit}
                                btnColor={`btnBlackPrime text-light ms-2`}
                                style={{ borderRadius: "5px", width: "80px" }}
                            // disabled={isLoading || Object.keys(localEdits).length === 0}
                            />
                        )}
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default TranslationInfoDialogue;
